var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('div',{staticClass:"list-area"},[(_vm.noData)?_c('div',{staticClass:"no-contents"},[_vm._v("조회 결과가 없습니다")]):_vm._e(),_c('program-detail-slider',{on:{"load-more":_vm.loadMoreProgramList}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }